import { render, staticRenderFns } from "./CustomerScreen.vue?vue&type=template&id=4d3a5090&scoped=true"
import script from "./CustomerScreen.vue?vue&type=script&lang=js"
export * from "./CustomerScreen.vue?vue&type=script&lang=js"
import style0 from "./CustomerScreen.vue?vue&type=style&index=0&id=4d3a5090&prod&scoped=true&lang=css"
import style1 from "./CustomerScreen.vue?vue&type=style&index=1&id=4d3a5090&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3a5090",
  null
  
)

export default component.exports